export enum AlarmState {
  NO_DATA = 'NO_DATA',
  OK = 'OK',
  OPEN = 'OPEN',
  CRITICAL = 'CRITICAL',
  ERROR = 'ERROR',
  WARNING = 'WARNING',
  INFO = 'INFO',
}

export const SEVERE_ALARM_STATES: AlarmState[] = [AlarmState.CRITICAL, AlarmState.ERROR, AlarmState.WARNING, AlarmState.INFO];

export function isSevereAlarmState(state: AlarmState) {
  return SEVERE_ALARM_STATES.includes(state);
}

export function determineDeliveryAlarmGroupState(alarms: { status: AlarmState }[]) {
  const alarmStates = new Set(alarms.map((alarm) => alarm.status));

  if (alarmStates.has(AlarmState.CRITICAL)) {
    return AlarmState.CRITICAL;
  }

  if (alarmStates.has(AlarmState.ERROR)) {
    return AlarmState.ERROR;
  }

  if (alarmStates.has(AlarmState.WARNING)) {
    return AlarmState.WARNING;
  }

  if (alarmStates.has(AlarmState.INFO)) {
    return AlarmState.INFO;
  }

  if (alarmStates.has(AlarmState.OK)) {
    return AlarmState.OK;
  }

  return AlarmState.NO_DATA;
}
